@if (showHeader) {
  <div class="d-flex align-items-center mb-2">
    <h2 class="nav-secondary nav-font14 font-weight-bold mb-0">Edit with AI</h2>
    <button type="button" class="btn btn-sm btn-link grey5 ml-auto p-0 panel-close"
            aria-label="Close Edit with AI"
            (click)="closed.emit()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
}

@if (disabled) {
  <p class="grey4 nav-font12 mb-0">Finish editing pages to use the assistant.</p>
} @else {
  <p class="grey4 nav-font12 mb-2">
    Describe a change — add a chart, rename a page, change the colours.
  </p>

  <!-- polite, not assertive: replies arrive while the user may still be reading the deck -->
  <div class="chat-log mb-2" aria-live="polite" aria-label="Conversation">
    @for (entry of entries(); track $index) {
      <div class="chat-entry nav-font12 mb-2" [class.chat-user]="entry.role === 'user'"
           [class.chat-error]="entry.role === 'error'">
        <span class="chat-who grey4 d-block">{{ entry.role === 'user' ? 'You' : 'Assistant' }}</span>
        {{ entry.text }}
      </div>
    }
    @if (sending()) {
      <p class="grey4 nav-font12 mb-0">
        <i class="fas fa-spinner fa-spin mr-1" aria-hidden="true"></i>Working on it…
      </p>
    }
  </div>

  <label for="report-chat-input" class="grey4 nav-font12 mb-1">Your request</label>
  <textarea id="report-chat-input"
            class="form-control form-control-sm nav-font12 mb-2"
            rows="3"
            [disabled]="sending()"
            [ngModel]="draft()"
            (ngModelChange)="draft.set($event)"
            (keydown.enter)="$event.preventDefault(); send()"></textarea>
  <button type="button"
          class="btn btn-sm btn-block chat-send shadow-none"
          [disabled]="sending() || !draft().trim()"
          (click)="send()">
    Send
  </button>
}
